﻿import { rootElement } from '@shared/setup';
import DataManagement from '@cwd/Account/DataManagement.vue';

const initDataManagement = async () => {
    rootElement({
        name: 'data-management', // pascal, camel & kebab-case are valid
        component: DataManagement,
        vm: {},
        contextComponents: ['<div>waiting</div>'],
    });
};
initDataManagement();
